export enum VlaioIconType {
	Solid = 'fa-solid',
	Regular = 'fa-regular',
	Thin = 'fa-thin',
	Light = 'fa-light',
	Custom = 'fa-kit'
}
